module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji"
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    ref: "cityAll",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticStyle: {
      "width": "98%",
      "display": "flex",
      "justify-content": "space-between",
      "text-align": "center",
      "margin": "0 auto"
    }
  }, [_c('p', [_vm._v("当前配置：" + _vm._s(_vm.nameOfProvince ? _vm.nameOfProvince : '全国') + " " + _vm._s(_vm.cityName) + " " + _vm._s(_vm.countyName))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("重要提示：本功能用于客源变现每个需求默认初始价格。")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, _vm._l((_vm.inputList), function(item, index) {
    return _c('div', {
      key: 'item-' + item.cluetypeid + '-' + index,
      staticClass: "grid-item"
    }, [_c('label', {
      staticClass: "labelClass",
      attrs: {
        "for": item.cluetypeid
      }
    }, [_vm._v(_vm._s(item.cluetypename))]), _vm._v(" "), _c('el-input', {
      style: ({
        marginLeft: '-2px'
      }),
      attrs: {
        "id": item.cluetypeid,
        "maxlength": "5",
        "onkeyup": "value=value.replace(/[^\\d]/g,'');"
      },
      model: {
        value: (item.price),
        callback: function($$v) {
          _vm.$set(item, "price", $$v)
        },
        expression: "item.price"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "line-height": "40px",
        "margin-left": "10px"
      }
    }, [_vm._v("元")])], 1)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iscityadmin == 0 || _vm.scid < 0),
      expression: "iscityadmin == 0 || scid < 0"
    }],
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin": "10px 0 20px 0"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addgoodcolunm()
      }
    }
  }, [_vm._v("保存")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d615a3ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/customprice.vue
// module id = 1751
// module chunks = 3